import { useState } from "react";
import Form3Registration from "./Form3Registration";
import Form1Place from "./Form1Place";
import Form4Success from "./Form4Success";
import { TypeParams } from "../../types";

interface EgwInfoterminRegistrationProps {
  params: TypeParams; // Define the type of the ccid prop
}

const EgwInfoterminRegistration: React.FC<EgwInfoterminRegistrationProps> = ({ params }) => {
  const [currentPlaceId, setCurrentPlace] = useState<null | number>(null);
  const [success, setSuccess] = useState<any>(null);

  // FORM 1 SUBMIT: send email or phone number to validate
  const commitCurrentPlace = async (placeId: number | null) => {
    setCurrentPlace(placeId);
    setSuccess(null);
  };

  const commitRegistration = async (response: any) => {
    setSuccess(response);
  };

  const HEADER = <></>;
  if (currentPlaceId && success) {
    return (
      <>
        {HEADER}
        <Form4Success params={params} placeId={currentPlaceId} />
      </>
    );
  }

  // STEP 3: FORM SUcommitRegistrationBMIT
  if (currentPlaceId) {
    return (
      <>
        {HEADER}
        <Form3Registration
          params={params}
          placeId={currentPlaceId}
          commitRegistration={commitRegistration}
          returnBackToDates={() => setCurrentPlace(null)}
        />
      </>
    );
  }

  return (
    <>
      {HEADER}
      <Form1Place params={params} commitCurrentPlace={commitCurrentPlace} origin="infotermin" />
    </>
  );
};

export default EgwInfoterminRegistration;
